import React from 'react';
import './Notification.css';

const usernames = [
  '_NivixX_',
  'Obvious',
  'Stuffman',
  'Boblenon',
  'Notch',
];

const activities = [
  'pille une base sur Faction',
  'découpe son adversaire',
  'prank son amis avec de a TNT',
  'gagne une partie de Skywar',
  'fini une mission sur GTA',
  'kill un bamby sur UHC',
  'craft une épée en diams',
  'fini sa base sur Faction',
  'joue à murder party',
  'chute au dernier bloc d\'un Parkour',
  'amre son canon a TNT sur Faction',
];


function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function randUsername() {
  return usernames[getRandomInt(usernames.length)];
}

function randActivity() {
  return activities[getRandomInt(activities.length)];
}

class Notification extends React.Component {
  constructor() {
    super();
    this.state = {
      a: {
        visibility: 'isSet',
        username: randUsername(),
        activity: randActivity(),
      },
      b: {
        visibility: 'isNotSet',
        username: '',
        activity: '',
      },
    };
    /*
    const { a, b } = this.state;
    this.state.currentNotification = a;
    this.state.nextNotification = b;
    */
  }

  componentDidMount() {
    setTimeout(() => {
      this.timerID = setInterval(
        () => this.tick(),
        4000,
      );
    }, 2500);
  }

  tick() {
    this.setState((prevState) => {
      const state = { ...prevState };

      // Note that the test includes the first case where a visibility is isSet
      if (state.a.visibility !== 'isHidden') {
        state.b.username = randUsername();
        state.b.activity = randActivity();
        state.b.visibility = 'isVisible';
        state.a.visibility = 'isHidden';
      } else {
        state.a.username = randUsername();
        state.a.activity = randActivity();
        state.a.visibility = 'isVisible';
        state.b.visibility = 'isHidden';
      }

      /*
      //-- V1
      // Identify notifications
      let currentNotification = state.a;
      let nextNotification = state.b;
      if (!state.a.visible) {
        currentNotification = state.b;
        nextNotification = state.a;
      }
      // Generate next notification and animate switching notifications
      nextNotification.username = randUsername();
      nextNotification.activity = randActivity();
      nextNotification.visible = true;
      currentNotification.visible = false;
      //-- v2
      // Generate next notification and animate switching notifications
      state.nextNotification.username = randUsername();
      state.nextNotification.activity = randActivity();
      state.nextNotification.visible = true;
      state.currentNotification.visible = false;
      // Switch currentNotification and nextNotification for the next tick
      const lastNotification = state.currentNotification;
      state.currentNotification = state.nextNotification;
      state.nextNotification = lastNotification;
      */
      return state;
    });
  }

  render() {
    const { a, b } = this.state;
    return (
      <div className="notifications slide animeWarper">
        <div id="notificiationA" className={`notification ${a.visibility}`}>
          <b>{a.username}</b> {a.activity}
        </div>
        <div id="notificiationB" className={`notification ${b.visibility}`}>
          <b>{b.username}</b> {b.activity}
        </div>
      </div>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/home/Notification.js